import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HabitDrillsListComponent } from '../habit-drills/components/habit-drills-list/habit-drills-list.component';
import { HabitFeedbackComponent } from '../habit-drills/components/habit-feedback/habit-feedback/habit-feedback.component';
import { HabitSubmissionComponent } from '../habit-drills/components/habit-submission/habit-submission/habit-submission.component';
import { HirationComponent } from './components/hiration/hiration.component';

import { DashboardComponent } from './container/dashboard/dashboard.component';
import { ProgramCompletionComponent } from './container/program-completion/program-completion.component';
import { ProfileComponent } from './profile/profile.component';

const routes: Routes = [
  { path: '', component: DashboardComponent  },
  { path: 'profile', component: ProfileComponent  },
  { path: 'habit-drills/:habitDrillUuid', component: HabitDrillsListComponent  },
  // { path: 'habit/:title', component: HabitDrillsListComponent  },
  { path: 'submission/:habitDrillUuid', component: HabitSubmissionComponent  },
  { path: 'feedback/:habitDrillUuid', component: HabitFeedbackComponent  },
  { path: 'reports-certificate', component: ProgramCompletionComponent  },
  { path: 'hiration', component: HirationComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
